
import { passwordChangeRequest, postPassword } from "@/api/password";
import { SCR240FormValidateRule } from "@/forms/scr240";
import useVuelidate from "@vuelidate/core";
import { defineComponent, reactive, ref, UnwrapRef } from "vue";
import ErrorField from "common/src/components/ErrorField.vue";
import { scrollToError } from "common/src/utils/screen";
import router from "@/router";
import axios from "axios";
import { setErrorMessage } from "common/src/utils/validate";
import { ErrorResponse } from "common/src/utils/request";
import { MutationTypes, useStore } from "@/store";

export default defineComponent({
  components: {
    ErrorField,
  },
  setup() {
    const form: UnwrapRef<passwordChangeRequest> = reactive({
      nowPassword: "",
      newPassword: "",
      newPasswordConfirm: "",
    });

    // 全体エラーメッセージ
    const g$: string[] = reactive([]);
    // フィールドエラーを外部からセットする変数
    const $externalResults = ref({});
    // フィールドエラー設定初期化
    const f$ = useVuelidate(SCR240FormValidateRule, form, {
      $externalResults,
    });

    const store = useStore();

    // パスワード変更処理呼び出し
    const submit = async () => {
      g$.splice(0, g$.length);
      f$.value.$touch();
      f$.value.$clearExternalResults();
      if (f$.value.$invalid) {
        scrollToError();
        return;
      }

      try {
        await postPassword(form);

        // パスワード変更必須ステートを書き換え
        store.commit(MutationTypes.PASSWORD_CHANGED);

        router.push({ name: "PasswordChanged" });
      } catch (err) {
        if (axios.isAxiosError(err) && err.response?.status === 400) {
          setErrorMessage(g$, $externalResults, err.response?.data as ErrorResponse);
          scrollToError();
        }
      }
    };

    return {
      form,
      g$,
      f$,
      submit,
    };
  },
});
